/**
 * TFS Deliveries (placeholder)
 *
 * Nav item added under Orders & Operations. The data source / integration is
 * not wired up yet — this is an intentional "coming soon" placeholder so the
 * route resolves. Replace with the real deliveries dashboard once the backend
 * feed exists (mirror UberDeliveries).
 */
import { Box, Typography } from '@mui/material';
import { AltRoute as TfsIcon } from '@mui/icons-material';
import { useAdminTheme } from '../admin-theme';

const TFSDeliveries = () => {
  const { colors, glassHeaderStyle } = useAdminTheme();

  return (
    <Box sx={{ bgcolor: colors.bgDeepest, minHeight: '100vh' }}>
      <Box sx={{ ...glassHeaderStyle, px: 3, py: 2.5 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: colors.textPrimary,
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <TfsIcon sx={{ fontSize: 32 }} />
          TFS Deliveries
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary, mt: 0.5 }}>
          Third-party fleet deliveries
        </Typography>
      </Box>

      <Box
        sx={{
          p: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 1.5,
          minHeight: '50vh',
        }}
      >
        <TfsIcon sx={{ fontSize: 64, color: colors.textMuted, opacity: 0.5 }} />
        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600 }}>
          Coming soon
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary, maxWidth: 420 }}>
          The TFS deliveries feed isn&apos;t connected yet. This section will show TFS
          delivery jobs and their live status once the integration is live.
        </Typography>
      </Box>
    </Box>
  );
};

export default TFSDeliveries;
